//const Rellax = require('rellax');
import Rellax from 'rellax';

document.addEventListener('DOMContentLoaded', function() {


    const navModal = document.querySelector('#animodal');
    const aniburgerContainer = document.querySelector('.aniburger-container');
    const hamburger = document.querySelector('.aniburger-container .hamburger');


    /**
    * toggle the state of the animation modal
     */

    function toggleNavModalState() {

	if ( navModal.classList.contains("active")) {

	    hamburger.classList.remove('open-hamburger');

	    navModal.classList.remove("active");
	    navModal.classList.add("inactive");



	} else if ( navModal.classList.contains("inactive")) {

	    hamburger.classList.add('open-hamburger');


	    navModal.classList.remove("inactive");
	    navModal.classList.add("active");


	} else {
	    console.log("toggleNavModalState: something has gone wrong");
	}

    }


    // handle nav button clicks
    document.addEventListener('click', function(e) {
	if (  e.target.matches('.animodal-control') || e.target.matches('.animodal-control *') ) {

	    e.preventDefault();
	    toggleNavModalState();

    } else if ( !e.target.matches('.animodal-control')) {
	console.log(e.target.classList);
    }

    });


    window.r = new Rellax('.rellax') ;



});
